import { ErrorHandler } from "@angular/core";
import { HttpConnectorError } from "../models/http-connector-error.model";
import { ErrorHandlingService } from '../services/error-handling.service';
import { LocatorService } from '../services/locator.service';

export class SmErrorHandler implements ErrorHandler {

    static instance: SmErrorHandler;
    onError: ((error: any) => void)[] = [];

    constructor() {
        SmErrorHandler.instance = this;
    }

    handleError(error: any): void {
        if (error?.name == "Canceled" && error?.stack?.includes("TextDiffComponent")) {
            return;
        }

        for (let f of this.onError) {
            f(error);
        }

        if (error instanceof HttpConnectorError) {
            if ([0, 502, 503, 504].includes(error.response.status)) {
                console.warn("Das Backend ist vorübergehend nicht erreichbar (" + (error.response.status == 0 ? "keine HTTP-Antwort" : "HTTP " + error.response.status) + "): " + (error.response.url ?? "URL unbekannt"));
                return;
            }
            if (error.response.status == 500 || error.response.status == 401 && error.response.message.includes("Unauthorized")) {
                return;
            }
        }

        console.log(error);
        console.trace(error);

        LocatorService.injector.get(ErrorHandlingService).reportToBackend(error as Error);
    }

    handleBackendError(errorId: string): void {
        LocatorService.injector.get(ErrorHandlingService).reportToBackend(new Error(), errorId);
    }
}
